import request from '@/utils/request'

export function register(data) {
  return request({
    url: '/auth/register',
    method: 'post',
    data
  })
}

export function login(data) {
  return request({
    url: '/auth/login',
    method: 'post',
    data
  })
}

export function sendSms(phone) {
  return request({
    url: '/auth/sms/send',
    method: 'post',
    data: { phone }
  })
}

export function smsLogin(data) {
  return request({
    url: '/auth/sms/login',
    method: 'post',
    data
  })
}

export function wxLogin(data) {
  return request({
    url: '/auth/wx-login',
    method: 'post',
    data
  })
}

export function getWxOAuthUrl() {
  return request({
    url: '/auth/wx-oauth-url',
    method: 'get'
  })
}
